export const setNumOrZero = (x: any) => {
	const parsed = Number(x);
	return Number.isNaN(parsed) ? 0 : parsed;
};
